export default {
  title: "Cartera",
  totalBalance: "Saldo total",
  wallet: "Wallet",
  tvl: "TVL",
  price: "Precio",
  marketcap: "Marketcap",
  pool: "Pool",
  liquidity: "Liquidez",
  apr: "APR",
  deposited: "Depositado",
  rewards: "Recompensas",
  claim: "Reclamar",
  claimAll: "Reclamar todo",
  available: "Disponible",
  staked: "Staked",
  obtainLP: "Obtener LP",
  poolsTitle: "Pools",
  depositLP: "Depositar LP",
  token: "Token",
  tokens: "Tokens",
  quantity: "Cantidad",
  amount: "Amount",
  value: "Valor",
  increase: "Aumentar",
  info: "Info",
  viewContract: "Ver contrato",
  addLP: "Add LP to your wallet",
  seeMore: "Ver más",
  seeLess: "Ver menos",
  noRewards: "Todavía no tienes recompensas",
  noPools: "Todavía no tienes pools",
  noTokens: "Todavía no tienes tokens",
  noNFTs: "Todavía no tienes NFTs",
  nft: "NFT",
  lock: "Bloqueado",
  deposits: "Depósitos",
  noDeposits: "Todavía no tienes depósitos",
  staking: "Staking",
  type: "Tipo",
}
